/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-denylist, id-match */

import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { SchemaField, Document, DocumentSchema, SystemFieldType } from 'src/app/modules/core/store/models/document.model';
import { DocumentReader } from 'src/app/modules/core/store/models/document-reader';
import { DynamicField } from '../dynamic-field';
import { ViewComponent } from '../../../store/models/workflow.model';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';

@Component({
    selector: 'app-url-field',
    templateUrl: './url-field.component.html',
    styleUrls: ['./url-field.component.scss'],
    standalone: false
})
export class UrlFieldComponent implements DynamicField, OnDestroy {
  @Output() valueChanged = new EventEmitter<DynamicField>();
  @Input() field: SchemaField;
  @Input() displayName: string;
  @Input() layerUId: string;
  @Input()
  set document(value: Document) {
    this.reader = new DocumentReader(value);
  }
  reader: DocumentReader;
  @Input() viewComponent: ViewComponent;
  isReadOnly: boolean;
  @Input() schema: DocumentSchema;
  @Input() dataset: Dataset;

  get value(): any {
    if (!this.url) {
      return null;
    }

    return `[${this.name}](${this.url})`;
  }
  set value(val: any) {
    this.populateNameAndValue(val);
  }

  showFieldAsEdit: boolean = false;
  private _isEdit: boolean = false;
  @Input() set isEdit(edit: boolean) {
    this._isEdit = edit;

    this.calculateShouldDisplayFieldForEdit();
  }

  url: string;
  name: string;

  constructor() {}

  ngOnDestroy(): void {
    this.valueChanged.complete();
  }

  calculateShouldDisplayFieldForEdit() {
    this.showFieldAsEdit = this._isEdit && !this.isReadOnly;
  }

  tpOnContentUpdated(): void {
    this.value = this.reader.getFieldValue(this.field?.systemName);

    if ((this.field.fieldType & SystemFieldType.Editable) !== SystemFieldType.Editable || this.viewComponent?.configuration?.isReadOnly) {
      this.isReadOnly = true;
      this.calculateShouldDisplayFieldForEdit();
    }
  }

  populateNameAndValue(value: string): void {
    if (!value) {
      this.url = '';
      this.name = '';
      return;
    }

    const linkMarkdownFormat = /^\[(?<name>.*)\]\((?<url>.*)\)$/gm;
    const match = linkMarkdownFormat.exec(value);
    this.name = match?.groups?.name;
    let url = match?.groups?.url;

    if (!url) {
      url = value;
    }

    url = url.replace(/^http:\/\//i, 'https://');

    if (!url.startsWith('https://')) {
      url = `https://${url}`;
    }
    this.url = url;

    if (!this.name) {
      this.name = url;
    }
  }

  onValueChanged(): void {
    this.valueChanged.emit(this);
  }
}
